import type { CatalogResource } from '../../types.js';
import { FEATURE_GROUP_KEYS } from '../feature-groups.js';
import { ROLE_KEYS } from '../roles.js';

const GROUP = FEATURE_GROUP_KEYS.VENDOR_COMPLIANCE;
const defaultGrants = {
  [ROLE_KEYS.COMPANY_ADMIN]: 'all',
  [ROLE_KEYS.COMPANY_CREATOR]: 'all',
  [ROLE_KEYS.COMPANY_READER]: ['read'],
} as const;

export const vendorCompliance = [
  {
    key: 'questionnaires',
    name: 'Questionnaires',
    description: 'Assessment requests and responses',
    group: GROUP,
    actions: ['create', 'read', 'edit', 'delete', 'archive'],
    grants: defaultGrants,
  },
  {
    key: 'certificates',
    name: 'Certificates',
    description: 'Certification records and validity',
    group: GROUP,
    actions: ['create', 'read', 'edit', 'delete', 'archive'],
    grants: defaultGrants,
  },
  {
    key: 'audit',
    name: 'Audit',
    description: 'Audits and findings',
    group: GROUP,
    actions: ['create', 'read', 'edit', 'delete', 'archive'],
    grants: defaultGrants,
  },
  {
    key: 'slcp',
    name: 'SLCP',
    description: 'Social & Labor Convergence assessments',
    group: GROUP,
    actions: ['read', 'edit', 'archive'],
    grants: defaultGrants,
  },
  {
    key: 'capa',
    name: 'CAPA',
    description: 'Corrective and preventive actions',
    group: GROUP,
    actions: ['create', 'read', 'edit', 'delete', 'archive'],
    grants: defaultGrants,
  },
  {
    key: 'documents',
    name: 'Documents',
    description: 'Compliance document library',
    group: GROUP,
    actions: ['create', 'read', 'edit', 'delete', 'archive'],
    grants: defaultGrants,
  },
] as const satisfies readonly CatalogResource[];
